<template>
  <div class="w1200" style="margin-top: 15px">
    <div class="bg" style="padding-top: 0">
      <div class="hd ys2">
        <h3 :title="list.typeName" style="width:600px">{{ list.typeName }}</h3>
        <div
          class="fr"
          v-if="
            userModule.roles.filter((el) => el.id == 'ThematicResourceManager').length > 0
          "
        >
          <el-button
            type="primary"
            size="mini"
            style="float: left; margin-right: 10px; margin-top: 9px"
            @click="upLoadAttribute = true"
            >修改专题</el-button
          >
          <upload1
            style="float: left; margin-right: 10px"
            :value="a"
            @input="uploadSectionFile"
            :size="1024 * 1024 * 3"
            :url="url"
            :auth="auth"
            ><el-button type="primary" size="mini">上传新资源</el-button>
          </upload1>
          <el-button type="primary" size="mini" @click="upLoadBaseShow = true"
            >引用资源库</el-button
          ><el-button type="primary" size="mini" style="" @click="delspecial"
            >删除当前专题</el-button
          >
        </div>
      </div>
      <div class="ztjs" style="padding-left: 15px">
        <el-input
          placeholder="请输入资源名称"
          v-model="search.userName"
          class="ztss1"
          size="small"
          style="width: 450px; padding: 10px 0"
        >
          <el-select
            slot="prepend"
            v-model="search.fileType"
            placeholder="文件类型"
            style="width: 100px; text-align: center"
          >
            <el-option label="全部" value=""> </el-option>
            <el-option
              v-for="item in fileTypeData"
              :key="'fileTypeData' + item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
          <!-- <i
            slot="suffix"
            style="color: #0096ff; cursor: pointer"
            class="el-input__icon el-icon-search"
          ></i> -->
        </el-input>
        <!-- <el-button type="primary" size="small">搜索</el-button> -->
      </div>
      <div class="bd">
        <!-- <el-radio-group v-model="sortOrder" @change="getData">
          <el-radio-button label="最新"></el-radio-button>
          <el-radio-button label="下载量"></el-radio-button>
          <el-radio-button label="收藏量"></el-radio-button>
        </el-radio-group> -->

        <div class="bd ys4">
          <ul>
            <li
              v-for="(d, i) in data
                .filter((el) => el.resourceName.includes(search.userName))
                .filter((el) =>
                  search.fileType === '' ? true : el.fileType == search.fileType
                )"
              :key="i"
            >
              <div class="icon">
                <svg class="icon" aria-hidden="true">
                  <use :xlink:href="'#icontbd' + d.fileType"></use>
                </svg>
                <!-- <em v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3"
                  >- {{ d.filePage }}页 -</em
                > -->
              </div>
              <div class="title">
                <h5 @click="yulan(d, 2)">{{ d.resourceName }}</h5>
                <span class="catalog">
                  <i>{{ d.resourceSourceDesc }}</i>
                </span>
                <span class="time">时间：{{ d.createTime.split(" ")[0] }}</span>
                <span class="download">下载量：{{ d.downloadNumber }}</span>
                <span class="collection">收藏量：{{ d.favoriteNumber }}</span>
                <span class="collection">浏览量：{{ d.visitedNumber }}</span>
                <span class="size">大小：{{ unit(d.fileSize) }}</span>
              </div>
              <div class="operate">
                <el-button
                  type="primary"
                  size="mini"
                  @click="downLoad(d, 2)"
                  v-if="list.downloadStatus == 1"
                  >下载</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  v-if="
                    userModule.roles.filter((el) => el.id == 'ThematicResourceManager')
                      .length > 0
                  "
                  @click="del(d)"
                  >删除</el-button
                >
                <el-button
                  v-if="d.isFavorite == 'Y'"
                  type="text"
                  size="mini"
                  @click="favorite(d)"
                  >收藏</el-button
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog title="修改资源" :visible.sync="upLoadAttribute" width="1230px">
      <attribute :list="list" @noDialog="noDialog" @getId="getId"></attribute>
    </el-dialog>
    <el-dialog title="引用资源库" :visible.sync="upLoadBaseShow" width="1230px">
      <quote
        :sectionData="sectionData"
        :activeName="activeName"
        :breadcrumb="breadcrumb"
        :breadcrumbData="breadcrumbData"
        :init1="init"
        @replace="analysisUrl"
        @add="add"
        v-model="data"
        ref="ref"
      ></quote>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="upLoadBaseShow = false">取 消</el-button>
        <el-button type="primary" @click="upLoadBaseShow = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import upload from "../../mixins/upload";
import yulan from "../../mixins/yulan";
import attribute from "./attribute";
import quote from "./quote";
import downLoad from "../../mixins/downLoad";
import upload1 from "../../common/upload1";
export default {
  data() {
    return {
      a: [],
      url: "",
      auth: {},
      search: {
        thematicTypeId: "",
        fileType: "",
        userName: "",
        page: 1,
        size: 10,
      },
      fileTypeData: [],
      data: [],
      sortOrder: "最新",
      previewUrl: "",
      uploadUrl: "",
      upLoadAttribute: false,
      upLoadBaseShow: false,
      breadcrumb: [],
      breadcrumbData: {
        section: "",
      },
      activeName: "",
      sectionData: [],
      list: { typeName: "", typeImage: "", new1: false },
    };
  },
  computed: {
    ...mapState(["userModule"]),
  },
  components: { attribute, quote, upload1 },
  mixins: [upload, yulan, downLoad],
  mounted() {
    this.init();
    this.analysisUrl();
    this.previewUrl = window.sessionStorage.getItem("previewUrl");
    this.uploadUrl = window.sessionStorage.getItem("uploadUrl");
    this.search.thematicTypeId = this.$route.query.id;
    this.list = {
      typeName: "",
      typeImage: "",
      new1: false,
      downloadStatus: false,
    };
    this.getData();
    this.url = window.sessionStorage.getItem("uploadUrl");
    this.auth = {
      clientId: window.sessionStorage.getItem("clientId"),
      token: window.sessionStorage.getItem("token"),
    };
  },
  methods: {
    delspecial() {
      if (this.data.length > 0) {
        this.$alert("当前专题包含资源，不可删除，请清空资源后重试！", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      } else {
        this.$ajax
          .post("/server/thematic/type/delete", {
            id: this.$route.query.id,
          })
          .then((res) => {
            this.$alert("专题删除成功！将返回列表页", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({ name: "special" });
              },
            });
          });
      }
    },
    favorite(d) {
      this.$ajax
        .post("/server/resource/common/favorite/thematic", {
          thematicResourceId: d.thematicResourceId,
        })
        .then((res) => {
          d.isFavorite = "N";
          d.favoriteNumber++;
        });
    },
    unit(v) {
      let arr = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      while (v > 1024) {
        i++;
        v = Math.floor((v * 100) / 1024) / 100;
      }
      return v + arr[i];
    },
    del(v) {
      this.$confirm("请确认是否删除资源", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let a = v.fileUrl.split("/")[1];
          axios
            .post(
              window.sessionStorage.getItem("uploadUrl") + "/" + a + "/deletefile",
              {
                Path: v.fileUrl,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  clientId: window.sessionStorage.getItem("clientId"),
                  token: window.sessionStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              if (res.data.suc) {
                this.$ajax
                  .post("/server/thematic/resource/delete", {
                    resourceId: v.thematicResourceId,
                  })
                  .then((res) => {
                    this.getData();
                  });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    getId() {},
    init() {
      this.$ajax.post("/common/load/file/type").then((res) => {
        this.fileTypeData = res;
      });
      this.$ajax
        .post("/server/thematic/type/detail", {
          thematicTypeId: this.$route.query.id,
        })
        .then((res) => {
          this.list = {
            typeName: res.typeName,
            typeImage: res.typeImage,
            new1: false,
            id: this.$route.query.id,
            downloadStatus: res.downloadStatus,
          };
        });
    },
    noDialog() {
      this.upLoadAttribute = false;
    },
    add(v) {
      v.thematicTypeId = this.search.thematicTypeId;
      this.$ajax
        .post("/server/thematic/resource/save", [v], {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.$message.success("保存成功");
          this.getData();
        });
    },
    analysisUrl() {
      this.sectionData = JSON.parse(window.sessionStorage.getItem("sectionData"));
      this.breadcrumbData = JSON.parse(window.sessionStorage.getItem("currentDirectory"));
      this.activeName = this.breadcrumbData.sectionId;
      this.breadcrumb = JSON.parse(window.sessionStorage.getItem("breadcrumb"));
      this.init++;
    },
    async uploadSectionFile(params) {
      params = params.map((el) => {
        let name = el.name.match(/([^\\/]+)\.([^\\/]+)/i);
        el.resourceName = name[1];
        el.thematicTypeId = this.$route.query.id;
        el.resourceSource = 1;
        return el;
      });

      this.$ajax
        .post("/server/thematic/resource/save", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.$message.success("保存成功");
          this.getData();
        });
    },
    getData() {
      let url = "/server/thematic/resource/listByDate";
      this.$ajax.post(url, this.search).then((res) => {
        this.data = res.list;
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/special/details.vue